<template>
	<div>
		<h1>
			Add a company value
		</h1>

		<form class="mt-4" @submit.prevent="createCompanyValue">
			<div class="form-group">
				<label for="content">
					<small class="text-muted">CONTENT</small>
				</label>
				<textarea class="form-control" name="content" placeholder="Value Content" v-model="content" required autofocus />
			</div>

			<div class="form-group">
				<label for="content">
					<small class="text-muted">IMAGE</small>
				</label>
				<file-input @change="setImage" placeholder="Choose image" multiple required />
			</div>

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading" :class="{running: loading}">
				{{ loading ? 'Adding…' : 'Add' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>


<script>
	import store from '../../../store';
	import FileInput from '../../FileInput';
	import {getError} from '../../../helpers';
	import {mapState} from 'vuex';

	export default {
		components: {
			'file-input': FileInput,
        },

        data() {
			return {
				image: null,
				content: '',
                
                loading: false,
				error: '',
			};
        },
        
        methods: {
			createCompanyValue() {
				this.loading = true;

				this.$store.dispatch('companyValues/create', {
					content: this.content,
					image: this.image,
				}).then(restaurant => {
					this.$router.push({name: 'settings'});
				}).catch(e => {
					this.error = getError(e);
					this.loading = false;
				});
            },

            setImage(files) {
				this.image = files[0];
			}
		},
		
		meta: {
			title: 'Add a company value',

			meta: [
				{property: 'og:title', content: 'Add a company value / Al-Shayah'},
			],
		},
    }
</script>